<form novalidate [formGroup]="form">
    <div class="input-group mb-3">
        <input id="search-input" type="text" placeholder="{{ 'msg#searchForm.searchFor' | sqMessage }}" formControlName="search" class="form-control" sqAutofocus>

        <button class="btn btn-primary" type="submit" (click)="search()" title="{{ 'msg#searchForm.search' | sqMessage }}">
            <i class="fas fa-fw fa-search"></i>
        </button>
    </div>
</form>